import { render, staticRenderFns } from "./GoodnessResultsComponent.vue?vue&type=template&id=c219b2ee&scoped=true"
import script from "./GoodnessResultsComponent.vue?vue&type=script&lang=js"
export * from "./GoodnessResultsComponent.vue?vue&type=script&lang=js"
import style0 from "./GoodnessResultsComponent.vue?vue&type=style&index=0&id=c219b2ee&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c219b2ee",
  null
  
)

export default component.exports